module.exports = __webpack_public_path__ + "static/media/logo_transparente.29e7c5a4.png";